export async function handleDeviceCircleResource(params) {
  const data = params.data;
  if (typeof params.data.devices !== 'undefined' && params.data.devices !== null) {
    data.devices = params.data.devices.map(d => d['@id'])
  }
  return data;
}
